import { EWatchlistCategory } from '@aqx-core/common/api/watchlist';
import mixpanel from '@aqx-core/common/mixpanel';
import { EAppThemeScheme } from '@aqx-core/common/theme';

import { eventNameHelper, eventPropertiesHelper, userHelper } from '../helpers';
import { EMixpanelEventNames, EMixpanelProperties, EPage } from '../types';
import { IActionClickProps } from './types';

class PageAnalysisService {
  public trackPageView = (page: string) => {
    mixpanel.registerSuperProperties({
      [EMixpanelProperties.PAGE]: page
    });
  };

  public pageClick = (page: EPage | undefined) => {
    const userAccountProperties = userHelper.createUserAccountProperties();
    mixpanel.track(EMixpanelEventNames.PAGE_CLICKED, {
      [EMixpanelProperties.PAGE]: page ?? '-',
      ...userAccountProperties
    });
  };

  public pageFullChartClick = (symbol: string) => {
    const userAccountProperties = userHelper.createUserAccountProperties();
    mixpanel.track(EMixpanelEventNames.PAGE_FULL_CHART_CLICKED, {
      [EMixpanelProperties.SYMBOL]: symbol ?? '-',
      ...userAccountProperties
    });
  };

  public actionClick = ({ action, symbol }: IActionClickProps) => {
    const eventName = eventNameHelper.mapActionClickEventName(action);
    const userAccountProperties = userHelper.createUserAccountProperties();
    mixpanel.track(eventName, {
      [EMixpanelProperties.SYMBOL]: symbol ?? undefined,
      ...userAccountProperties
    });
  };

  public watchlistClick = (watchList: EWatchlistCategory) => {
    const watchLists = eventPropertiesHelper.mapWatchListEventProperties(watchList);
    const userAccountProperties = userHelper.createUserAccountProperties();
    mixpanel.track(EMixpanelEventNames.WATCHLIST_CLICKED, {
      [EMixpanelProperties.WATCHLIST_TYPE]: watchLists ?? '-',
      ...userAccountProperties
    });
  };

  public appearancePreferenceClick = (themeScheme: EAppThemeScheme) => {
    const themeSchemes = eventPropertiesHelper.mapThemeSchemeEventProperties(themeScheme);
    const userAccountProperties = userHelper.createUserAccountProperties();
    mixpanel.track(EMixpanelEventNames.APPEARANCE_PREFERENCE_CLICKED, {
      [EMixpanelProperties.APPEARANCE_PREFERENCE]: themeSchemes ?? '-',
      ...userAccountProperties
    });
  };

  public confirmLinkAccountClick = (newWetatraderID: string | undefined) => {
    const userAccountProperties = userHelper.createUserAccountProperties();
    mixpanel.track(EMixpanelEventNames.CONFIRM_LINK_ACCOUNT_CLICKED, {
      [EMixpanelProperties.NEW_ACCOUNT_METATRADER_ID]: newWetatraderID ?? '-',
      ...userAccountProperties
    });
  };
}

const pageAnalysisService = new PageAnalysisService();
export default pageAnalysisService;
